(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('ActionCommandsController', ActionCommandsController);

    ActionCommandsController.$inject = ['$rootScope', '$scope', '$state', 'TabActions', 'TabObjects', 'TabActionsQueue', 'AlertService', 'ParseLinks', 'id', 'Queue', 'Macro', '$uibModal', '$filter','$timeout', '$window', '$interval', 'CommandManifest'];

    function ActionCommandsController($rootScope, $scope, $state, TabActions, TabObjects, TabActionsQueue, AlertService, ParseLinks, id, Queue, Macro, $uibModal, $filter, $timeout, $window, $interval, CommandManifest) {
        var vm = this;
        var commandStash = {};

        vm.commandToSend = false;
        vm.tabObjects = [];
        vm.predicates = {};
        vm.page = 0;
        vm.tabActionsQueue = {commands: [], object: {}};
        vm.tabActionsQueue.isCron = false;
        vm.tabActionsQueue.alias = "";
        vm.charToSearch = "";
        vm.currentState = "action-commands";
        vm.actionDeviceReleaseMap = {};
        vm.clickMacro = false;
        vm.commandStash = [];
        vm.originalTable = [];
        vm.isQueue = true;
        vm.commAside = false;
        vm.redrawInterval = null;
        vm.isGreengrassObject = false; // Track if current object is Greengrass type
        //boolean to set page ready
        vm.pageReady = false;

        vm.init = function (){
            vm.licence = $rootScope.licence;
            vm.setAsideTop();
            $scope.$on("sf-render-finished", function(){
                $interval.cancel(vm.redrawInterval);
                vm.redrawInterval = $interval(function (){
                    vm.resizeTrigger();
                    $interval.cancel(vm.redrawInterval);
                }, 10);
            })
        };

        window.addEventListener('resize', function (){
            vm.setAsideTop();
        });

        vm.resizeTrigger = function (){
            $window.dispatchEvent(new Event("resize"));
        };

        vm.setAsideTop = function (){
            var headerHeight = $(".navbar-fixed-top").height();
            $(".command-sidebar-aside").css('top', headerHeight + 25);
            $(".aside-open-button").css('top',headerHeight + 35);
        }

        vm.toggleQueue = function() {
            vm.isQueue = !vm.isQueue;
            vm.showSchedule = undefined;
        };

        if (id !== null && id !== undefined) {
            TabObjects.get({id: id}).$promise.then(function (data) {
                vm.obj = data;
                vm.fetchActions(data);
            });
        }

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder !== null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        vm.selectObject = function (obj) {
            $state.transitionTo($state.$current, {
                id: obj.id
            }, {notify: true, location: "replace"});
        };

        vm.loadAll = function () {
            var requestedQuery = vm.charToSearch;

            TabObjects.query({
                page: vm.page,
                size: 20,
                query: vm.charToSearch,
                sort: sort()
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                // scarta risposte obsolete
                if (requestedQuery !== vm.charToSearch) {
                    console.log('Ignoring obsolete response for: ' + requestedQuery + " current search is: " + vm.charToSearch);
                    return;
                }
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjects.push(data[i]);
                }
                vm.pageReady = true;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.reset = function () {
            vm.page = 0;
            vm.commandStash = [];
            vm.commAside = false;
            vm.tabActions = [];
            vm.loadAll();
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();

        vm.search = function (searchText) {
            vm.charToSearch = searchText;
            vm.page = 0;
            vm.tabObjects = [];
            vm.loadAll();
        };

        // Helper to recompute vm.clickMacro based on actual stash contents
        function updateClickMacroFlag() {
            vm.clickMacro = vm.commandStash.some(function(cmd) {
                return cmd.macro === true;
            });
        }

        vm.fetchActions = function (obj) {
            vm.tabActionsQueue.commands = [];
            vm.tabActionsQueue.object = obj;

            // Track if current object is Greengrass type
            vm.isGreengrassObject = obj.objectType && obj.objectType.greengrassType === true;

            // Check if Greengrass object is offline
            function onSuccessMacro(data) {
                vm.macro = [];
                for(var i = 0; i < data.length; i++){
                    vm.macro.push(data[i]);
                }
            }

            function onErrorMacro(error) {
                console.error('Error fetching  macros:', error);
                AlertService.error('Failed to fetch macros for object');
            }
            // Check if greengrassType is true
            if (obj.objectType && obj.objectType.greengrassType === true) {

                // Call CommandManifest service for greengrass objects
                if (typeof CommandManifest !== 'undefined' && CommandManifest !== null) {
                    CommandManifest.get({objectUniqueCode: obj.objectUniqueCode}, onSuccessManifest, onErrorManifest);

                    function onSuccessManifest(manifestData) {
                        // Fetch Greengrass macros
                        Macro.queryGreengrass({id: obj.id, page: vm.page}, onSuccessMacro, onErrorMacro);
                        var transformedData = transformManifestToTabActions(manifestData, obj);
                        onSuccess(transformedData);
                    }

                    function onErrorManifest(error) {
                        AlertService.error(error.data.message);
                    }
                } else {
                    console.error('CommandManifest service is not defined!');
                    AlertService.error('CommandManifest service is not available');
                }
            } else {
                // Original flow for non-greengrass objects
                Macro.query({id: obj.id, page: vm.page}, onSuccessMacro, onErrorMacro);

                TabActions.command({id: obj.id}, onSuccess, onError);
            }

            function transformManifestToTabActions(manifestData, obj) {
                var result = [];

                if (!manifestData || !manifestData.manifest) {
                    console.warn('Invalid manifest data:', manifestData);
                    return result;
                }

                console.log('%c=== GREENGRASS MANIFEST TRANSFORMATION ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Original Greengrass manifest data:', manifestData);

                Object.keys(manifestData.manifest).forEach(function(componentName) {
                    var commands = manifestData.manifest[componentName];

                    console.log('%cProcessing component: ' + componentName, 'color: #2196F3; font-weight: bold;');
                    console.log('Commands in component:', commands);

                    commands.forEach(function(command, index) {
                        var argumentsSchema = null;

                        if (command.arguments && (Array.isArray(command.arguments) && command.arguments.length > 0 ||
                            (typeof command.arguments === 'object' && Object.keys(command.arguments).length > 0))) {

                            argumentsSchema = convertGreengrassArgumentsToJsonSchema(command.arguments);
                        }

                        var tabAction = {
                            id: 1000 + result.length,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            permissionLevel: command.permission_level || 1,
                            weight: command.weight || 1,
                            argumentsSchema: argumentsSchema ? angular.toJson(argumentsSchema) : null,
                            deviceReleases: {
                                id: 500 + result.length,
                                deviceReleaseName: componentName,
                                deviceReleaseDescription: 'Greengrass component: ' + componentName,
                                isActive: true,
                                deviceReleaseVersion: '1.0.0',
                                device: {
                                    id: 200 + result.length,
                                    deviceName: componentName.split('.').pop(),
                                    deviceDescription: 'Greengrass device for ' + componentName,
                                    isActive: true,
                                    isVisibile: true,
                                    deviceType: {
                                        id: 100,
                                        deviceTypeName: 'Greengrass Component Type',
                                        deviceTypeDescription: 'AWS IoT Greengrass Component',
                                        isActive: true,
                                        isVisibile: true,
                                        entityId: 100
                                    },
                                    entityId: 200 + result.length
                                },
                                entityId: 500 + result.length
                            }
                        };

                        console.log('%cCommand #' + (index + 1) + ': ' + command.command_name, 'color: #FF9800;');
                        console.log('  - Arguments Schema:', argumentsSchema);
                        console.log('  - Transformed TabAction:', tabAction);

                        result.push(tabAction);
                    });
                });

                console.log('%c=== TRANSFORMATION COMPLETE ===', 'color: #4CAF50; font-weight: bold; font-size: 14px;');
                console.log('Total commands transformed:', result.length);
                console.log('Final result:', result);

                return result;
            }

            function convertGreengrassArgumentsToJsonSchema(greengrassArgs) {
                var properties = {};
                var required = [];
                var order = 1;

                console.log('  Converting arguments:', greengrassArgs);

                var argsArray = Array.isArray(greengrassArgs) ? greengrassArgs :
                    (typeof greengrassArgs === 'object' ? [] : []);

                if (argsArray.length === 0 && typeof greengrassArgs === 'object' && !Array.isArray(greengrassArgs)) {
                    console.log('  No arguments to convert');
                    return null;
                }

                argsArray.forEach(function(arg) {
                    var key = arg.key;
                    var props = arg.props || {};

                    var property = {
                        description: props.description || props.label || '',
                        title: key,
                        type: mapGreengrassTypeToJsonSchemaType(arg.type)
                    };

                    if (arg.defaultValue !== undefined && arg.defaultValue !== null) {
                        property.default = arg.defaultValue;
                    }

                    property.order = order++;

                    if (arg.type === 'timepicker') {
                        property.format = 'time';
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                        property.options = {
                            step: 1,
                            floor: props.min !== undefined ? props.min : 0,
                            ceil: props.max !== undefined ? props.max : 100
                        };
                        property.minimum = props.min;
                        property.maximum = props.max;
                        if (props.thumbLabel !== undefined) {
                            property.thumbLabel = props.thumbLabel;
                        }
                    }

                    if (arg.type === 'select' && props.options && props.options.length > 0) {
                        property.titleMap = props.options.map(function(option) {
                            return {
                                name: option.label,
                                value: String(option.value)
                            };
                        });

                        property.enum = props.options.map(function(option) {
                            return String(option.value);
                        });

                        if (property.default !== undefined && property.default !== null) {
                            property.default = String(property.default);
                        }
                    }

                    if (arg.type === 'slider') {
                        property.component = 'range';
                    }

                    if (props.required) {
                        required.push(key);
                    }

                    properties[key] = property;

                    console.log('  - Property "' + key + '":', property);
                });

                var schema = {
                    metricReference: {},
                    type: 'object',
                    properties: properties
                };

                if (required.length > 0) {
                    schema.required = required;
                }

                console.log('  Final schema:', schema);

                return schema;
            }

            function mapGreengrassTypeToJsonSchemaType(greengrassType) {
                switch(greengrassType) {
                    case 'slider':
                        return 'number';
                    case 'toggle':
                        return 'boolean';
                    case 'text':
                    case 'input':
                    case 'timepicker':
                        return 'string';
                    case 'select':
                        return 'string';
                    default:
                        return 'string';
                }
            }



            function onSuccess(data) {
                console.log('%c=== FORM CREATION FROM DATA ===', 'color: #9C27B0; font-weight: bold; font-size: 14px;');
                console.log('Data received in onSuccess:', data);

                vm.tabActions = [];
                vm.formSchemas = {
                    forms: [],
                    buttons: []
                };
                for (var i = 0; i < data.length; i++) {
                    $scope.formSchema = [];
                    vm.tabActions.push(data[i]);
                    vm.actionDeviceReleaseMap[data[i].actionCommand] = {
                        idAction: data[i].id,
                        deviceReleases: {
                            deviceReleaseName: data[i].deviceReleases.deviceReleaseName
                        },
                        permissionLevel: data[i].permissionLevel
                    };

                    console.log('%cProcessing command: ' + data[i].actionCommand, 'color: #9C27B0; font-weight: bold;');

                    if (data[i].argumentsSchema != null) {
                        var jArg = angular.fromJson(data[i].argumentsSchema);
                        console.log('  Parsed argumentsSchema:', jArg);

                        var first = Object.keys(jArg.properties)[0];
                        if (jArg.properties[first].hasOwnProperty('order')) {
                            console.log('  Using ORDER-based sorting');
                            var orderProps = [];
                            orderProps.length = Object.keys(jArg.properties).length;
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                orderProps.splice(Number(jArg.properties[val].order) - 1, 1, entry);
                            });
                            orderProps.forEach(function (val) {
                                $scope.formSchema.push(val);
                            });
                        } else {
                            console.log('  Using NATURAL ordering');
                            Object.keys(jArg.properties).forEach(function (val) {
                                var entry = vm.getEntry(jArg, val, null);
                                console.log('    Entry for "' + val + '":', entry);
                                $scope.formSchema.push(entry);
                            });
                        }

                        var formToAdd = {
                            command: data[i].actionCommand,
                            description: data[i].description,
                            form: $scope.formSchema,
                            schema: jArg,
                            weight: data[i].weight,
                            showPending: false
                        };

                        Object.keys(jArg.properties).forEach(function(propKey) {
                            if (jArg.properties[propKey].hasOwnProperty('default')) {
                                formToAdd[propKey] = jArg.properties[propKey].default;
                            }
                        });

                        console.log('  Form to add:', formToAdd);
                        vm.formSchemas.forms.push(formToAdd);
                    } else {
                        console.log('  No arguments - adding as BUTTON');
                        vm.formSchemas.buttons.push({
                            command: data[i].actionCommand
                        });
                    }
                }

                console.log('%cFinal formSchemas:', 'color: #9C27B0; font-weight: bold;');
                console.log('  Forms:', vm.formSchemas.forms);
                console.log('  Buttons:', vm.formSchemas.buttons);

                var tempFormBig = [];
                var tempFormMedium = [];
                var tempFormSmall = [];
                var tempLineArray = [];
                angular.forEach(vm.formSchemas.forms, function (value, i) {
                    if (value.weight == 1) {
                        tempFormSmall.push(value);
                    }
                    else if (value.weight == 2) {
                        tempFormMedium.push(value);
                    }
                    else if (value.weight == 3) {
                        tempFormBig.push(value);
                    }
                });

                while (tempFormSmall.length != 0 || tempFormMedium.length != 0 || tempFormBig.length != 0) {
                    if (tempFormBig.length > 0) {
                        tempLineArray.push({form: [tempFormBig.shift()], type: '3'});
                    }
                    else if (tempFormSmall.length > 0 && tempFormMedium.length > 0) {
                        tempLineArray.push({form: [tempFormSmall.shift(), tempFormMedium.shift()], type: '2-1-1'});
                    }
                    else if (tempFormSmall.length > 0) {
                        while (tempFormSmall.length > 0) {
                            if (tempFormSmall.length > 1) {
                                tempLineArray.push({
                                    form: [tempFormSmall.shift(), tempFormSmall.shift(), tempFormSmall.shift(), tempFormSmall.shift()],
                                    type: '1-1-1-1'
                                });
                            }
                            else {
                                tempLineArray.push({form: [tempFormSmall.shift()], type: '1'});
                            }
                        }
                    }
                    else if (tempFormMedium.length > 0) {
                        tempLineArray.push({form: [tempFormMedium.shift()], type: '2'});
                    }
                }


                vm.formSchemas.forms = [];
                angular.forEach(tempLineArray, function (value, i) {
                    angular.forEach(value.form, function (form, index) {
                        if (form !== undefined) {
                            vm.formSchemas.forms.push(form);
                        }
                    });
                });

                angular.forEach(vm.formSchemas.forms,  function(cmd){
                    if(!isCommandValued(cmd)){
                        var command = {name: cmd.command, rowSpan: cmd.form.length}
                        var pos = 0;
                        while(!isCommandValue(cmd.form[pos], command)){
                            pos ++;
                        }
                        vm.originalTable.push({command: command, metricName: cmd.form[pos].title, metricValue: getValue(cmd.form[pos],cmd), description: cmd.description})
                        for(var i = pos+1; i < cmd.form.length; i++){
                            if(!isCommandValue(cmd.form[i],cmd)){
                                vm.originalTable.push({metricName: cmd.form[i].title, metricValue: getValue(cmd.form[i],cmd), command: {name:null}});
                            }
                        }
                    }
                });

                function getValue(form, command){
                    return isCommandValue (form, command) ? form.schema.default : command[form.title];
                }

                function isCommandValue(form, command){
                    return command[form.title] === undefined || command[form.title] === null || isNaN(command[form.title]);
                }

                function isCommandValued(command){
                    var check = false;
                    var forms = command.form;
                    for(var i = 0;  i < forms.length; i++){
                        check = check || isCommandValue(forms[i],command)
                    }
                    return check;
                }

                var tempCommands;

                tempCommands = vm.tabActions.filter( function(command){
                    return vm.originalTable.findIndex(function (commandInQueue){
                        return command.actionCommand === commandInQueue.command.name
                    }) < 0
                });

                var notValuedCommands = tempCommands.map(function (oldCommand){
                    return {
                        metricName: null,
                        metricValue: null,
                        description: oldCommand.description,
                        command: {
                            name: oldCommand.actionCommand
                        }
                    }
                });


                vm.originalTable = vm.originalTable.concat(notValuedCommands);

            }


            function onError(error) {
                AlertService.error(error.data.message);
            }

        };

        vm.getEntry = function (jArg, val, arrayName) {
            var entry = {};
            if (arrayName != null)
                entry.key = arrayName + "[]." + val;
            else
                entry.key = val;
            if (jArg.properties[val].hasOwnProperty('titleMap')) {
                entry.titleMap = jArg.properties[val].titleMap;
                entry.type = 'select';
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
                if (jArg.properties[val].hasOwnProperty("pending")) {
                    jArg.properties[val].titleMap.forEach(function (title) {
                        if (title.value === jArg.properties[val].pending)
                            jArg.properties[val].pending = title.name;
                    });
                }
            }
            if (jArg.properties[val].type === 'string' && !jArg.properties[val].hasOwnProperty('titleMap')) {
                if (jArg.properties[val].format === 'time') {
                    entry.type = 'timepicker';
                } else {
                    entry.type = 'text';
                }
                entry.title = jArg.properties[val].title || val;
                entry.description = jArg.properties[val].description || '';
                entry.schema = jArg.properties[val];
                if (jArg.required && jArg.required.indexOf(val) !== -1) {
                    entry.required = true;
                }
            }
            if (jArg.properties[val].hasOwnProperty('component') && !jArg.properties[val].hasOwnProperty('titleMap'))
                entry.type = jArg.properties[val].component;
            if (jArg.properties[val].hasOwnProperty('options'))
                entry.options = jArg.properties[val].options;
            if (jArg.properties[val].hasOwnProperty('style'))
                entry.style = jArg.properties[val].style;
            if (jArg.properties[val].hasOwnProperty('maxDate'))
                entry.maxDate = jArg.properties[val].maxDate;
            if (jArg.properties[val].hasOwnProperty('minDate'))
                entry.minDate = jArg.properties[val].minDate;
            if (jArg.properties[val].hasOwnProperty('format') && jArg.properties[val].format == 'time') {
                if (jArg.properties[val].default && typeof jArg.properties[val].default === 'string') {
                    var timeParts = jArg.properties[val].default.split(':');
                    var timeDate = new Date();
                    timeDate.setHours(parseInt(timeParts[0]) || 0);
                    timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                    timeDate.setSeconds(0);
                    timeDate.setMilliseconds(0);
                    jArg.properties[val].default = timeDate;
                }
            }
            if (jArg.properties[val].hasOwnProperty('default')) {
                jArg.properties[val].defaultRestore = angular.copy(jArg.properties[val].default);
            }
            if (jArg.properties[val].hasOwnProperty('items')) {
                entry.items = [];
                var first = Object.keys(jArg.properties[val].items.properties)[0];
                if (jArg.properties[val].items.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(jArg.properties[val].items.properties).length;
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        orderProps.splice(Number(jArg.properties[val].items.properties[item].order) - 1, 1, vm.getEntry(jArg.properties[val].items, item, val));
                    });
                    orderProps.forEach(function (val) {
                        entry.items.push(val);
                    });
                } else {
                    Object.keys(jArg.properties[val].items.properties).forEach(function (item) {
                        entry.items.push(vm.getEntry(jArg.properties[val].items, item, val));
                    });
                }
            }
            return entry;
        };

        vm.saveQueueOrMacro = function (actionExec) {
            vm.isSaving = true;

            // block saving a macro that contains another macro
            if (actionExec === 'saveMacro' && vm.isGreengrassObject && vm.clickMacro) {
                AlertService.error("Cannot save a macro that contains another macro.");
                vm.isSaving = false;
                return;
            }

            if(vm.tabActionsQueue.single){
                if(vm.tabActionsQueue.cron === true && vm.repeatNumber && vm.repeatTime) {
                    vm.tabActionsQueue.cronExpression = vm.repeatNumber  + " " + vm.repeatTime;
                } else if(vm.tabActionsQueue.cron === true && (!vm.repeatNumber || !vm.repeatTime)) {
                    AlertService.error("Fill Repetition fields");
                    return;
                }
            }

            vm.tabActionsQueue.commands = vm.commandStash;
            if(actionExec == "saveQueue"){
                for(var i = 0; i < vm.tabActionsQueue.commands.length; i++){
                    var commandName = vm.tabActionsQueue.commands[i].actionCommand.split(' - ');
                    var command = commandName[0];
                    vm.tabActionsQueue.commands[i].actionCommand = command;
                }
                Queue.create(vm.tabActionsQueue, onSuccess, onError);
            } else {
                vm.macroNameCheck = true;
                vm.nameErrorMsg = "";
                angular.forEach(vm.macro, function (macro){
                    if (macro.alias === vm.tabActionsQueue.alias){
                        vm.macroNameCheck = false;
                    }
                });
                if (vm.macroNameCheck) {
                    Macro.create(vm.tabActionsQueue, onSuccess, onError);
                } else {
                    vm.nameErrorMsg = "Macro name already exists, choose a new name"
                    AlertService.error(vm.nameErrorMsg);
                };
            }

            function onSuccess() {
                $state.transitionTo($state.$current, {
                    id: id
                }, {notify: true, location: "replace", reload: true});
            }

            function onError(error) {
                AlertService.error(error.data.message);
                vm.clear();
            }
        };

        vm.deleteCommand = function (commandId) {
            TabActionsQueue.delete({id: commandId}, onSuccess, onError);

            function onSuccess() {
                $state.transitionTo($state.$current, {
                    id: id
                }, {notify: true, location: "replace", reload: true});
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.clear = function () {

            $timeout(function() {
                $window.dispatchEvent(new Event("resize"));
            }, 300);

            commandStash = {};
            vm.commandStash = [];
            vm.commAside = false;
            vm.commandToSend = false;
            vm.clickMacro = false; // reset macro flag on clear
            vm.fetchActions(vm.obj);
            vm.tabActionsQueue.alias = "";
            vm.macroNameCheck = true;
        };

        vm.fillEntity = function (entity, commandName, withArgs) {
            vm.cleanEntity(entity, commandName, withArgs);
            vm.commandToSend = true;
        };

        vm.remove = function(index) {
            vm.commandStash.splice(index, 1);
            updateClickMacroFlag();
            if(Object.keys(vm.commandStash).length == 0){
                vm.clear();
            }
        }

        vm.moveUp = function(index) {
            var obj = vm.commandStash[index];
            vm.commandStash.splice(index, 1);
            vm.commandStash.splice(index - 1, 0, obj);
        }

        vm.moveDown = function(index) {
            var obj = vm.commandStash[index];
            vm.commandStash.splice(index, 1);
            vm.commandStash.splice(index + 1, 0, obj);
        }

        vm.cleanEntity = function (entity, commandName, withArgs) {
            if (withArgs) {
                var args = {};
                for (var key in entity.schema.properties) {
                    if (entity[key] instanceof Date) {
                        var hours = entity[key].getHours();
                        var minutes = entity[key].getMinutes();
                        args[key] = String(hours).padStart(2, '0') + ":" + String(minutes).padStart(2, '0');
                    } else {
                        args[key] = entity[key];
                    }
                }
            }
            vm.commandStash.push({
                id: vm.actionDeviceReleaseMap[commandName].idAction,
                actionCommand: commandName,
                deviceReleases: vm.actionDeviceReleaseMap[commandName].deviceReleases,
                arguments: args,
                permissionLevel: vm.actionDeviceReleaseMap[commandName].permissionLevel
            });
        };

        $scope.storeChanges = function (action) {

            $timeout(function() {
                $window.dispatchEvent(new Event("resize"));
            }, 300);

            if (typeof action === "string") {
                sendZeroArgumentAction(action);
            } else {
                sendMultiArgumentAction.call(this, action);
            }
        };

        $scope.storeChangesMacro = function (macro) {
            vm.tabActionsQueue.alias = macro.alias;

            if (vm.isGreengrassObject) {
                // For Greengrass: get queue commands and merge with manifest data
                Macro.getMacroDetails({macroId: macro.id}, onSuccessGreengrassMacro, onErrorGreengrassMacro);

                function onSuccessGreengrassMacro(queueCommands) {
                    console.log('Greengrass macro queue commands:', queueCommands);

                    queueCommands.forEach(function(qc) {
                        var parsedArguments = {};
                        try {
                            parsedArguments = qc.arguments ? JSON.parse(qc.arguments) : {};
                        } catch (e) {
                            console.error('Failed to parse arguments:', e);
                        }

                        // Find matching command in manifest
                        var matchingCommand = vm.tabActions.find(function(action) {
                            return action.actionCommand === qc.commandName;
                        });

                        if (matchingCommand) {
                            vm.commandStash.push({
                                id: matchingCommand.id,
                                actionCommand: qc.commandName + " - " + macro.alias,
                                deviceReleases: matchingCommand.deviceReleases,
                                arguments: parsedArguments,
                                permissionLevel: matchingCommand.permissionLevel,
                                macro: true
                            });
                        } else {
                            console.warn('Command not in manifest:', qc.commandName);
                            AlertService.error('Failed to load macro detail');
                        }
                    });

                    vm.commandToSend = true;
                    vm.commAside = true;
                    updateClickMacroFlag();
                }

                function onErrorGreengrassMacro(error) {
                    console.error('Error loading macro:', error);
                    AlertService.error('Failed to load macro details');
                }

            } else {
                // Original non-Greengrass flow
                macro.macroActions.sort(function (a, b) {
                    return a.order - b.order;
                });

                for(var i = 0; i < macro.macroActions.length; i++){
                    var commandName = macro.macroActions[i].tabActions.actionCommand + " - " + macro.alias;
                    vm.commandStash.push({
                        id: macro.macroActions[i].tabActions.id,
                        actionCommand: commandName,
                        deviceReleases: macro.macroActions[i].tabActions.deviceReleases,
                        arguments: macro.macroActions[i].arguments == "{}" ? {} : macro.macroActions[i].argumentMap,
                        macro: true
                    });
                }

                vm.commandToSend = true;
                vm.commAside = true;
                updateClickMacroFlag();
            }
        };

        function sendZeroArgumentAction(action) {
            if (commandStash[action] !== null && commandStash[action] !== undefined) {
                delete commandStash[action];
                vm.commandToSend = !(Object.keys(commandStash).length === 0);
            } else
                vm.fillEntity({}, action, false);
            vm.commAside = true;
        }

        function sendMultiArgumentAction(action) {
            var commandName = action.command;
            if (this[commandName] !== undefined)
                $scope.$broadcast('schemaFormValidate', this[commandName].$name);
            if (this[commandName] === undefined || this[commandName].$valid) {
                vm.fillEntity(action, commandName, true);
            }
            vm.commAside = true;
        };

        vm.removeChanges = function (formSchema) {
            delete commandStash[formSchema.command];
            for (var value in formSchema) {
                if (value != "command" && value != "form" && value != "schema" && value != "$$hashKey" && value != "weight" && value != "showPending" && value != "description") {
                    if (formSchema.schema.properties[value].type == 'array' && formSchema.schema.properties[value].defaultRestore === undefined) {
                        formSchema[value] = [{}];
                    }
                    else {
                        formSchema[value] = angular.copy(formSchema.schema.properties[value].defaultRestore);
                    }
                }
            }
            $('#' + formSchema.command).removeAttr("disabled");
            vm.commandToSend = !(Object.keys(commandStash).length === 0);
        };

        vm.commAside = false;
        vm.toggleCommAside = function() {
            if(vm.commandStash.length != 0)
                vm.commAside = !vm.commAside;

            $timeout(function() {
                vm.resizeTrigger();
            }, 300);
        };

        vm.scheduleCommands = function () {
            if(vm.showSchedule === undefined)
                vm.response = {
                    single: false
                };
            $uibModal.open({
                templateUrl: 'app/management/action-commands/schedule-commands.html',
                controller: 'ScheduleCommandsController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function() {
                        return vm.response;
                    }
                }
            }).result.then(function (result) {
                if(result.scheduleDateTime !== undefined || result.selectedDay !== undefined) {
                    vm.response = result;
                    if (vm.response.single) {
                        setData();
                    } else {
                        setMultipleData();
                    }
                    vm.tabActionsQueue.single = vm.response.single;
                } else
                    vm.showSchedule = undefined;
            });
        };

        function setMultipleData() {
            vm.tabActionsQueue.weeklyCron = [];
            vm.showSchedule = "SCHEDULED:\nREPEAT\n";
            angular.forEach(vm.response.selectedDay, function(day){
                if(day.includeDay) {
                    var schedule = convertWeeklyDate(day);
                    vm.showSchedule += schedule;
                }
            });
            vm.showSchedule = vm.showSchedule.slice(0, -1);
        }

        function convertWeeklyDate(day) {
            var dateFormat = 'HH:mm';
            var tempDate = angular.copy(day.selectedTime);
            var date = $filter('date')(new Date(convertToUTC(tempDate)), dateFormat);
            var cron = date.split(":");

            vm.tabActionsQueue.weeklyCron.push(cron[1] + " " + cron[0] + " " + checkDay(day.day));
            var dateToShow = $filter('date')(new Date(day.selectedTime), dateFormat);
            return " " + day.day + " EVERY " + dateToShow + "\n";
        }

        function convertToUTC(date) {
            var offset = new Date().getTimezoneOffset();
            var hours = Math.floor(offset/60);
            var minutes = offset % 60;
            date.setHours(date.getHours() + hours);
            date.setMinutes(date.getMinutes() + minutes);
            return date;
        }

        function checkDay(day) {
            switch (day){
                case "MON":
                    return 1;
                case "TUE":
                    return 2;
                case "WED":
                    return 3;
                case "THU":
                    return 4;
                case "FRI":
                    return 5;
                case "SAT":
                    return 6;
                case "SUN":
                    return 7;
            }
        }

        function setData() {
            vm.tabActionsQueue.scheduleDateTime = vm.response.scheduleDateTime;
            vm.tabActionsQueue.cron = vm.response.cron;
            vm.repeatNumber = vm.response.repeatNumber;
            vm.repeatTime = vm.response.repeatTime;
            convertDate();
        }

        function convertDate(){
            var dateFormat = 'dd/MM/yyyy';
            var date = $filter('date')(new Date(vm.tabActionsQueue.scheduleDateTime), dateFormat);
            vm.showSchedule = "SCHEDULED: " + date + "\n";
            if(vm.tabActionsQueue.cron === true && vm.repeatNumber && vm.repeatTime) {
                vm.showSchedule += " REPEAT EVERY " + vm.repeatNumber  + " " + vm.repeatTime;
            } else if(vm.tabActionsQueue.cron === true && (!vm.repeatNumber || !vm.repeatTime)) {
                AlertService.error("Fill Ripetition fields");
                vm.showSchedule = undefined;
            }
        }

        vm.commandsView = function () {
            if(vm.showSchedule === undefined)
                vm.response = {
                    single: false
                };
            $uibModal.open({
                templateUrl: 'app/management/action-commands/commands-view.html',
                controller: 'CommandsView',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return vm.formSchemas.forms;
                    },
                    commandsArray: function () {
                        return vm.tabActions;
                    }
                }
            });
        };


    }
})();
